function sortByNome (obj1, obj2) {
  return obj1.nome > obj2.nome ? 1 : -1
}

export const funcoes = [
  {
    codigo: 'ADMINISTRATIVO',
    nome: 'Administrativo'
  },
  {
    codigo: 'FISCALIZADOR',
    nome: 'Fiscalizador'
  },
  {
    codigo: 'GEOMENSOR',
    nome: 'Geomensor'
  },
  {
    codigo: 'LEVANTAMENTO_SOCIO_ECONOMICO',
    nome: 'Levantamento Socioeconômico'
  },
  {
    codigo: 'VISTORIADOR',
    nome: 'Vistoriador'
  },
  {
    codigo: 'OUTROS',
    nome: 'Outros'
  }
]

export const statusSolicitacao = [
  {
    codigo: 'PENDENTE',
    nome: 'Pendente'
  },
  {
    codigo: 'RESPONDIDA',
    nome: 'Respondida'
  },
  {
    codigo: 'ENCERRADA',
    nome: 'Encerrada'
  },
  {
    codigo: 'CANCELADA',
    nome: 'Cancelada'
  }
]

export const situacaoTituloCertidao = [
  {
    codigo: 'AGUARDANDO_ASSINATURA',
    nome: 'Aguardando Assinatura'
  },
  {
    codigo: 'AGUARDANDO_ATUALIZACAO_BASE',
    nome: 'Aguardando Atualização Base'
  },
  {
    codigo: 'AGUARDANDO_ENTREGA',
    nome: 'Aguardando Entrega'
  },
  {
    codigo: 'AGUARDANDO_VALIDACAO_BASE',
    nome: 'Aguardando Validação Base'
  },
  {
    codigo: 'ENTREGUE',
    nome: 'Entregue'
  },
  {
    codigo: 'FINALIZADO',
    nome: 'Finalizado'
  }
]

export const situacaoTituloCertidaoAp = [
  {
    codigo: 'AGUARDANDO_ASSINATURA',
    nome: 'Aguardando Assinatura'
  },
  {
    codigo: 'AGUARDANDO_ENTREGA',
    nome: 'Aguardando Entrega'
  },
  {
    codigo: 'ENTREGUE',
    nome: 'Entregue'
  },
  {
    codigo: 'FINALIZADO',
    nome: 'Finalizado'
  }
]

export const situacaoTituloCertidaoBa = [
  {
    codigo: 'AGUARDANDO_ASSINATURA',
    nome: 'Aguardando Assinatura'
  },
  {
    codigo: 'AGUARDANDO_ENTREGA',
    nome: 'Aguardando Entrega'
  },
  {
    codigo: 'ENTREGUE',
    nome: 'Entregue'
  }
]

export const situacaoTituloCertidaoMa = [
  {
    codigo: 'AGUARDANDO_IMPRESSAO_TITULO',
    nome: 'Aguardando impressão do título'
  },
  {
    codigo: 'AGUARDANDO_ENTREGA_TITULO',
    nome: 'Aguardando entrega do título'
  },
  {
    codigo: 'EM_ENTREGA_TITULO',
    nome: 'Em entrega título'
  },
  {
    codigo: 'AGUARDANDO_BOLETO',
    nome: 'Aguardando emissão do boleto'
  },
  {
    codigo: 'AGUARDANDO_PAGAMENTO',
    nome: 'Aguardando pagamento'
  },
  {
    codigo: 'FINALIZADO',
    nome: 'Finalizado'
  },
  {
    codigo: 'PROCESSO_DEFERIDO',
    nome: 'Processo deferido'
  },
  {
    codigo: 'AGUARDANDO_ELABORACAO_ERRATA_TITULO',
    nome: 'Aguardando elaboração de errata de título'
  },
  {
    codigo: 'EM_ELABORACAO_ERRATA_TITULO',
    nome: 'Em elaboração de errata de título'
  },
  {
    codigo: 'AGUARDANDO_IMPRESSAO_ERRATA_TITULO',
    nome: 'Aguardando impressão de errata'
  },
  {
    codigo: 'TITULO_COM_ERRATA',
    nome: 'Título com errata'
  },
  {
    codigo: 'AGUARDANDO_ASSINATURA_ERRATA_TITULO',
    nome: 'Aguardando assinatura de errata'
  },
  {
    codigo: 'TITULO_CANCELADO',
    nome: 'Título cancelado'
  }
].sort(sortByNome)

export const situacoesCertidao = [
  {
    codigo: 'ENTREGUE',
    nome: 'Entregue'
  },
  {
    codigo: 'AGUARDANDO_ENTREGA',
    nome: 'Aguardando Entrega'
  },
  {
    codigo: 'AGUARDANDO_ASSINATURA',
    nome: 'Aguardando Assinatura'
  }
]

export const tiposRR = [
  {
    codigo: 'NAO_ONEROSO',
    nome: 'Não Oneroso'
  },
  {
    codigo: 'ONEROSO',
    nome: 'Oneroso'
  }
]

export const tipos = [
  {
    codigo: 'AREAS_PATRIMONIAIS',
    nome: 'Áreas Patrimoniais'
  },
  {
    codigo: 'CANCELAMENTO_CLAUSULA_RESOLUTIVA',
    nome: 'Cancelamento de cláusula resolutiva'
  },
  {
    codigo: 'CERTIDAO_TITULO',
    nome: 'Certidão de Título'
  },
  {
    codigo: 'INFORMACOES',
    nome: 'Informação de Título'
  },
  {
    codigo: 'NAO_ONEROSO',
    nome: 'Não Oneroso'
  },
  {
    codigo: 'ONEROSO',
    nome: 'Oneroso'
  },
  {
    codigo: 'PEAEX',
    nome: 'PEAEX'
  },
  {
    codigo: 'PEAS',
    nome: 'PEAS'
  },
  {
    codigo: 'PERMUTA',
    nome: 'Permuta'
  },
  {
    codigo: 'REGULARIZACAO_URBANA',
    nome: 'Regularização Urbana'
  },
  {
    codigo: 'AFORAMENTO',
    nome: 'Resgate de Aforamento'
  },
  {
    codigo: 'TEQ',
    nome: 'TEQ'
  },
  {
    codigo: 'TRANSFERENCIA_DIREITOS',
    nome: 'Transferência de Direitos'
  },
  {
    codigo: 'REURB_COLETIVO',
    nome: 'Reurb coletivo'
  },
  {
    codigo: 'TQ',
    nome: 'TQ'
  },
  {
    codigo: 'EXTRATO_SENTENCA',
    nome: 'Extrato Sentença'
  },
  {
    codigo: 'RETIFICACAO',
    nome: 'Retificação Online'
  }
]

export const situacaoClausulaResolutiva = [
  {
    codigo: 'AGUARDO_ANALISE_MONITORAMENTO',
    nome: 'Aguardando análise de jurisdição e/ou de monitoramento ambiental'
  }
]

export const tiposNaoOnerosoGroup = [
  {
    codigo: 'CERTIDAO_TITULO',
    nome: 'Certidão de Título'
  },
  {
    codigo: 'NAO_ONEROSO',
    nome: 'Não Oneroso'
  },
  {
    codigo: 'ONEROSO',
    nome: 'Oneroso'
  },
  {
    codigo: 'AFORAMENTO',
    nome: 'Resgate de Aforamento'
  },
  {
    codigo: 'AREAS_PATRIMONIAIS',
    nome: 'Áreas Patrimoniais'
  }
]

export const tiposPeasGroup = [
  {
    codigo: 'PEAEX',
    nome: 'PEAEX'
  },
  {
    codigo: 'PEAS',
    nome: 'PEAS'
  },
  {
    codigo: 'TEQ',
    nome: 'TEQ'
  }
]

export const statusOs = [
  {
    codigo: 'EM_ANALISE',
    nome: 'Em Análise'
  },
  {
    codigo: 'FINALIZADA',
    nome: 'Finalizada'
  },
  {
    codigo: 'AGUARDANDO_ANALISE',
    nome: 'Aguardando análise'
  }
]

export const estadoCivil = [
  {
    codigo: 'CASADO',
    nome: 'Casado(a)'
  },
  {
    codigo: 'DIVORCIADO',
    nome: 'Divorciado(a)'
  },
  {
    codigo: 'SEPARADO',
    nome: 'Separado(a)'
  },
  {
    codigo: 'SOLTEIRO',
    nome: 'Solteiro(a)'
  },
  {
    codigo: 'UNIAO_ESTAVEL',
    nome: 'União Estável'
  },
  {
    codigo: 'UNIAO_HOMOAFETIVA',
    nome: 'União Homoafetiva'
  },
  {
    codigo: 'VIUVO',
    nome: 'Viúvo(a)'
  }
]

export const situacaoBoleto = [
  {
    codigo: 'AGUARDANDO_PAGAMENTO',
    nome: 'Aguardando Pagamento'
  },
  {
    codigo: 'AGUARDANDO_EMISSAO_BOLETO',
    nome: 'Aguardando Emissão de Boleto'
  },
  {
    codigo: 'QUITADO',
    nome: 'Quitado'
  },
  {
    codigo: 'VENCIDO',
    nome: 'Vencido'
  },
  {
    codigo: 'AGUARDANDO_CONFIRMACAO_INTERESSADO',
    nome: 'Aguardando confirmação do interessado'
  },
  {
    codigo: 'AGUARDANDO_CALCULO_VTN',
    nome: 'Aguardando cálculo do VTN'
  },
  {
    codigo: 'CANCELADO',
    nome: 'Cancelado'
  }
]

export const situacoesCPAV = [
  {
    codigo: 'AGUARDANDO_CONFIRMACAO_INTERESSADO',
    nome: 'Aguardando confirmação do interessado'
  },
  {
    codigo: 'AGUARDANDO_CALCULO_VTN',
    nome: 'Aguardando cálculo do VTN'
  }
]

export const situacaoCaixaEntradaGac = [
  {
    codigo: 'AGUARDANDO_ANALISE',
    nome: 'Aguardando Análise'
  },
  {
    codigo: 'AGUARDANDO_EMISSAO',
    nome: 'Aguardando Emissão do DAE'
  }
]

export const situacaoCaixaEntradaCdiGit = [
  {
    codigo: 'AGUARDANDO_ANALISE',
    nome: 'Aguardando Análise'
  },
  {
    codigo: 'AGUARDANDO_EMISSAO_CERTIDAO',
    nome: 'Aguardando Emissão da Certidão'
  },
  {
    codigo: 'AGUARDANDO_EMISSAO_TITULO',
    nome: 'Aguardando Emissão do Título'
  }
]

export const situacaoEmAnaliseCdiGit = [
  {
    codigo: 'EM_ANALISE',
    nome: 'Em Análise'
  },
  {
    codigo: 'EM_EMISSAO_CERTIDAO',
    nome: 'Emissão da Certidão'
  },
  {
    codigo: 'EM_EMISSAO_TITULO',
    nome: 'Emissão do Título'
  }
]

export const situacaoAguardandoValidacaoCdiGit = [
  {
    codigo: 'AGUARDANDO_VALIDACAO',
    nome: 'Aguardando Validação da Análise'
  },
  {
    codigo: 'AGUARDANDO_VALIDACAO_CERTIDAO',
    nome: 'Aguardando Validação da Certidão'
  },
  {
    codigo: 'AGUARDANDO_CONFERENCIA_TITULO',
    nome: 'Aguardando Conferência de Título'
  },
  {
    codigo: 'AGUARDANDO_CONFERENCIA_CERTIDAO',
    nome: 'Aguardando Conferência da Certidão'
  }
]

export const situacaoCustas = [
  {
    nome: 'Aguardando cálculo de custas',
    codigo: 'AGUARDANDO_CALCULO_CUSTAS'
  },
  {
    nome: 'Aguardando a emissão do boleto da custas',
    codigo: 'AGUARDANDO_EMISSAO_BOLETO_CUSTAS'
  },
  {
    nome: 'Aguardando o pagamento do boleto de custas',
    codigo: 'AGUARDANDO_PAGAMENTO_BOLETO_CUSTAS'
  }
]

export const situacaoArquivado = [
  {
    codigo: 'FINALIZADO',
    nome: 'Finalizado'
  },
  {
    codigo: 'ARQUIVADO',
    nome: 'Arquivado'
  }
]

export const situacoesArquivados = [
  {
    codigo: 'ARQUIVADO',
    nome: 'Arquivado'
  }
]

export const situacaoArquivadoGea = [
  {
    codigo: 'FINALIZADO',
    nome: 'Finalizado'
  },
  {
    codigo: 'ARQUIVADO',
    nome: 'Arquivado'
  },
  {
    codigo: 'AGUARDANDO_ARQUIVAMENTO',
    nome: 'Aguardando Arquivamento'
  },
  {
    codigo: 'EM_ARQUIVAMENTO',
    nome: 'Em Arquivamento'
  }
]

export const atividades = [
  {
    label: 'Cultura Permanente',
    value: 'CULTURA_PERMANENTE'
  },
  {
    label: 'Cultura Temporária',
    value: 'CULTURA_TEMPORARIA'
  },
  {
    label: 'Edificações',
    value: 'EDIFICACOES'
  },
  {
    label: 'Outras Atividades',
    value: 'OUTRAS_ATIVIDADES'
  },
  {
    label: 'Semoventes',
    value: 'SEMOVENTES'
  }
]

export const unidadeDeProducao = [
  {
    id: 1,
    descricao: 'Arroba(s)',
    value: 'ARROBA'
  },
  {
    id: 2,
    descricao: 'Cacho(s)',
    value: 'CACHOS'
  },
  {
    id: 3,
    descricao: 'Cento(s) de Frutos',
    value: 'CENTO_DE_FRUTOS'
  },
  {
    id: 4,
    descricao: 'Quilo(s)',
    value: 'QUILO'
  },
  {
    id: 5,
    descricao: 'Saco(s) de 50 Kg',
    value: 'SACO_50_KG'
  },
  {
    id: 6,
    descricao: 'Saco(s) de 60 Kg',
    value: 'SACO_60_KG'
  },
  {
    id: 7,
    descricao: 'Tonelada(s)',
    value: 'TONELADA'
  }
]

export const unidadeMedicao = [
  {
    id: 1,
    descricao: 'Metros (m)',
    value: 'METROS'
  },
  {
    id: 2,
    descricao: 'Metros Cúbicos (m³)',
    value: 'METROS_CUBICOS'
  },
  {
    id: 3,
    descricao: 'Metros Quadrados (m²)',
    value: 'METROS_QUADRADOS'
  },
  {
    id: 4,
    descricao: 'Quilômetro (km)',
    value: 'QUILOMETRO'
  }
]

export const coordenadas = [
  {
    descricao: 'Norte',
    value: 'NORTE'
  },
  {
    descricao: 'Sul',
    value: 'SUL'
  },
  {
    descricao: 'Leste',
    value: 'LESTE'
  },
  {
    descricao: 'Oeste',
    value: 'OESTE'
  },
  {
    descricao: 'Lado esquerdo',
    value: 'LADO_ESQUERDO'
  },
  {
    descricao: 'Lado direito',
    value: 'LADO_DIREITO'
  }
]

export const situacaoBA = [
  {
    codigo: 'EM_REVISAO',
    nome: 'Em Revisão'
  }
]

export const situacaoAssinaturaGabBA = [
  {
    codigo: 'AGUARDANDO_ASSINATURA_EXTRATO_SENTENCA',
    nome: 'Aguardando assinatura do extrato de sentença'
  },
  {
    codigo: 'AGUARDANDO_ASSINATURA_TITULO',
    nome: 'Aguardando assinatura do título'
  }
]

export const situacaoCadastroPendente = [
  {
    codigo: 'AGUARDANDO',
    nome: 'Aguardando Georreferenciamento e Laudo de Vistoria'
  },
  {
    codigo: 'AGUARDANDO_LAUDO_VISTORIA',
    nome: 'Aguardando Laudo de Vistoria'
  },
  {
    codigo: 'AGUARDANDO_GEORRENFENCIAMENTO',
    nome: 'Aguardando Georreferenciamento'
  },
  {
    codigo: 'CONCLUIDO',
    nome: 'Concluído'
  }
]

export const situacaoCadastroPendenteGeo = [
  {
    codigo: 'EM_ANDAMENTO',
    nome: 'Em andamento'
  },
  {
    codigo: 'AGUARDANDO_NUMERO_RECIBO',
    nome: 'Aguardando número do recibo'
  },
  {
    codigo: 'CONCLUIDO',
    nome: 'Concluído'
  }
]

export const situacaoCaixaEntradaVistoriaRemota = [
  {
    codigo: 'AGUARDANDO_RESPOSTA_INTERESSADO',
    nome: 'Aguardando resposta do interessado'
  },
  {
    codigo: 'AGUARDANDO_ANALISE',
    nome: 'Aguardando análise'
  }
]

export const situacaoCaixaEmAnaliseVistoriaRemota = [
  {
    codigo: 'AGUARDANDO_GERACAO',
    nome: 'Aguardando geração'
  },
  {
    codigo: 'EM_ANDAMENTO',
    nome: 'Em andamento'
  },
  {
    codigo: 'FINALIZADO',
    nome: 'Finalizado'
  }
]

export const perfisDJ = [
  {
    codigo: 'ADVOGADO',
    nome: 'Advogado'
  },
  {
    codigo: 'ASSESSOR',
    nome: 'Assessor'
  },
  {
    codigo: 'DIRETOR_JURIDICO',
    nome: 'Diretor Jurídico'
  },
  {
    codigo: 'PROCURADOR',
    nome: 'Procurador'
  },
  {
    codigo: 'PROCURADOR_ADMINISTRATIVO',
    nome: 'Procuradoria Administrativa'
  },
  {
    codigo: 'PROCURADOR_JURIDICO',
    nome: 'Procuradoria Jurídica'
  }
]



// WEBPACK FOOTER //
// ./src/constants/selects.js